<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [noMessage]="noMessage()" [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input"
           (onActivateLink)="onActivateLink.emit()">
    <div class="decimal-field">
        <input #input class="decimal-field-input" [attr.id]="inputId()"
               [value]="displayValue()" (input)="handleInputEvent($event)"
               type="text" inputmode="decimal" [attr.autocomplete]="autocomplete()"
               [attr.maxlength]="maxlength()" [attr.pattern]="'[0-9]*'" [readOnly]="readOnly()"
               (keydown)="DecimalFieldComponent.validateCharacter($event)"
               (keyup)="DecimalFieldComponent.correctInput($event)"
               [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        @if (!valueSignal()) {
            <div class="decimal-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
</woa-field>
